import { CLASS_NAMES, DOM_EVENTS } from "./constants/constants-imports.es6.js";

const DESKTOP_BREAKPOINT = 1023;

export default class OverlayService {
  constructor() {
    this.mobileOverlay = document.querySelector('.mobile-overlay');
    this.desktopOverlay = document.querySelector('.desktop-overlay');
    this.headerOverlay = document.querySelector('.header-overlay');
    this.body = document.querySelector('body');
  }

  setTransparency(globalNavOpened) {
    if (globalNavOpened || OverlayService.getIsMobile()) {
      this.desktopOverlay.classList.remove('transparent');
      this.headerOverlay.classList.remove('transparent');
      this.mobileOverlay.classList.remove('transparent');
    } else {
      this.desktopOverlay.classList.add('transparent');
      this.headerOverlay.classList.add('transparent');
      this.mobileOverlay.classList.add('transparent');
    }
  }

  /**
   * Show or hide the desktop, mobile, and header overlays for use in
   *
   * @param {boolean} enable true to show the overlays, false to hide them
   * currently open
   * @param {function():void} clickHandler the callback function for when the
   * overlay is clicked
   * @param {boolean} globalNavOpened whether or not the global navigation is
   * currently open
   * @param {boolean} inactivateSiteHeader whether or not the site header should
   * be usable when the overlay is enabled
   */
  toggleOverlay(enable, clickHandler, globalNavOpened = false, inactivateSiteHeader = true) {
    if (enable) {
      this.body.classList.add('disable-scroll');
      this.desktopOverlay.classList.add('active');
      if (OverlayService.getIsMobile()) {
        this.mobileOverlay.classList.add('active');
      } else {
        this.headerOverlay.classList.add('active');
      }
    } else {
      this.body.classList.remove('disable-scroll');
      this.desktopOverlay.classList.remove('active');
      this.mobileOverlay.classList.remove('active');
      this.headerOverlay.classList.remove('active');
    }

    this.setTransparency(globalNavOpened);

    const isHeaderClickable = !enable || !inactivateSiteHeader;
    OverlayService.toggleHeaderClickability(isHeaderClickable);

    if (clickHandler) {
      this.desktopOverlay.addEventListener(DOM_EVENTS.CLICK, clickHandler, { once: true });
      this.mobileOverlay.addEventListener(DOM_EVENTS.CLICK, clickHandler, { once: true });
      this.headerOverlay.addEventListener(DOM_EVENTS.CLICK, clickHandler, { once: true });
    }
  }

  static getIsMobile() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  static toggleHeaderClickability(clickable) {
    const element = document.querySelector('.site-header');
    if (clickable) {
      element.classList.remove(CLASS_NAMES.INACTIVE);
    }
    else {
      element.classList.add(CLASS_NAMES.INACTIVE);
    }
  }
}

(() => {})(Drupal);
